// SPDX-License-Identifier: AGPL-3.0-or-later

import {CheckIcon} from '@app/features/ui/icons/Icons';
import styles from '@app/features/user/components/modals/tabs/appearance_tab/cards/ChoiceCards.module.css';
import React from 'react';

interface ChoiceCardProps {
	name: string;
	description?: string;
	checked: boolean;
	disabled?: boolean;
	preview: React.ReactNode;
	onSelect: () => void;
	onKeyDown?: (event: React.KeyboardEvent<HTMLButtonElement>) => void;
	'data-flx'?: string;
}

/** A large radio card: a preview on top, a radio, name and description below. */
export const ChoiceCard = React.forwardRef<HTMLButtonElement, ChoiceCardProps>(
	({name, description, checked, disabled, preview, onSelect, onKeyDown, 'data-flx': dataFlx}, ref) => (
		<button
			ref={ref}
			type="button"
			role="radio"
			aria-checked={checked}
			tabIndex={checked ? 0 : -1}
			disabled={disabled}
			className={styles.card}
			onClick={onSelect}
			onKeyDown={onKeyDown}
			data-flx={dataFlx}
		>
			{preview}
			{checked && (
				<span className={styles.check} aria-hidden="true">
					<CheckIcon size={16} weight="bold" />
				</span>
			)}
			<span className={styles.label}>
				<span className={styles.radio} aria-hidden="true" />
				<span>
					<span className={styles.name}>{name}</span>
					{description && <span className={styles.description}>{description}</span>}
				</span>
			</span>
		</button>
	),
);
ChoiceCard.displayName = 'ChoiceCard';

export {styles as choiceCardStyles};
